export default __webpack_public_path__ + "static/media/topbar-rectangle.ff3af387.png";